export const ACTIONS_DATA_ATTRIBUTE_IDS = {
  Table: {
    AddUnitCost: 'InventoryManager.Actions.Table.AddUnitCost',
    AddReorderDays: 'InventoryManager.Actions.Table.AddReorderDays',
    AddLeadTime: 'InventoryManager.Actions.Table.AddLeadTime'
  }
}
